import { memo, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { CART_PAYMENT_FOOTER } from './constants/dom-ids';
import * as Styled from './styles';
import { CartBack } from '../../__partials/CartBack';
import { CartClose } from '../../__partials/CartClose';
import * as StyledShared from '../../styles';
import { lazy } from 'utils/generic/lazy';
import { Configs } from 'constants/app/configs';
import { ViewModes } from 'interfaces';

const { CartPaymentFtnftAmLayout } = lazy(
  () =>
    import(
      /* webpackChunkName: "CartPaymentFtnftAmLayout" */ './layouts/FtnftAm'
    )
);

const { CartPaymentDefaultLayout } = lazy(
  () =>
    import(
      /* webpackChunkName: "CartPaymentDefaultLayout" */ './layouts/Default'
    )
);

const { CartPaymentKioskLayout } = lazy(
  () =>
    import(/* webpackChunkName: "CartPaymentKioskLayout" */ './layouts/Kiosk')
);

const CART_PAYMENT_CONTENT = {
  [ViewModes.DEFAULT]: CartPaymentDefaultLayout,
  [ViewModes.KIOSK]: CartPaymentKioskLayout,
  [ViewModes.FTNFT_AM]: CartPaymentFtnftAmLayout,
  [ViewModes.KIOSK_AM]: CartPaymentFtnftAmLayout
};

export const CartPayment = memo(() => {
  const { t } = useTranslation();
  const CartPaymentContent = CART_PAYMENT_CONTENT[Configs.VIEW_MODE];

  return (
    <StyledShared.CartContainer>
      <StyledShared.CartHeaderNavigation>
        <CartBack />
        <Styled.CartHeaderNavigationStep>
          {t('payment.payments')}
        </Styled.CartHeaderNavigationStep>
        <CartClose />
      </StyledShared.CartHeaderNavigation>
      <Styled.CartBodyWrapper>
        <Styled.CartBodyTitle>
          {t('payment.purchaseTitle')}
        </Styled.CartBodyTitle>
        <Styled.NftPriceSummary />
        <Suspense fallback={null}>
          <CartPaymentContent />
        </Suspense>
      </Styled.CartBodyWrapper>
      <Styled.CartFooter id={CART_PAYMENT_FOOTER} />
    </StyledShared.CartContainer>
  );
});
